
import {map} from 'rxjs/operators';
import { Component, Input } from '@angular/core';
import { LawService } from '../services/law.service';
import { NavService } from '../services/nav.service';
import { Observable, Subject, BehaviorSubject ,  of } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Law, LawNavItem } from '../models/models';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'law-library-view',
    templateUrl: './law-library-view.component.html',
    styleUrls: ['./law-library-view.component.scss'],
    standalone: false
})
export class LawLibraryViewComponent {
    public view$: Observable<SafeHtml>;
    public _law: LawNavItem | Law;
    set law(value: LawNavItem | Law) {
        this._law = value;
        this.onLawSet.next(value);
    }
    get law(): LawNavItem | Law {
        return this._law;
    }

    public onLawSet: BehaviorSubject<LawNavItem | Law> = new BehaviorSubject(null);
    

    @Input()
    public set navItem(val: LawNavItem | Law) {
        this._law = val;

        if ((this._law as Law).data)
            this.view$ = of(this.domSanitizer.bypassSecurityTrustHtml(
                (this._law as Law).data));
        else
            this.view$ = this.lawService.getLaw(this._law.id).pipe(
                map(s => this.domSanitizer.bypassSecurityTrustHtml(s.data)));
    }

    @Input()
    public set view(val: string) {
        this.view$ = of(this.domSanitizer.bypassSecurityTrustHtml(val));
    }

    constructor(
        protected lawService: LawService,
        protected domSanitizer: DomSanitizer,
        protected activatedRoute: ActivatedRoute,
        protected navService: NavService
    ) {
        if (this.activatedRoute.data) {
            this.view$ = activatedRoute.data.pipe(map((result: { law: Law }) => {
                this.law = result.law;
                return this.domSanitizer.bypassSecurityTrustHtml(result.law.data)
            }));
        }


    }

}
